import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/registrations/Login';
import Signup from './pages/registrations/Signup';
import Forgot from './pages/registrations/Forgot';
import Reset from './pages/registrations/Reset';
import Dashboard from './pages/Dashboard';
import Header from './components/partials/Header';
import Footer from './components/partials/Footer';
import SideBar from './components/partials/SideBar';
import CCPAForm from './pages/CCPA';
import PrivacyRequests from './pages/PrivacyRequests';
import Ringba from './pages/Ringba';
import PixelLog from './pages/PixelLog'
import { connect } from 'react-redux';
import './App.css';
import HomeListManagement from './components/partials/HomeListManagement';
import HomeTrustDatagenetx from './components/partials/HomeTrustDatagenetx';
import HomeGetStarted from './components/partials/HomeGetStarted';


function App(props) {
  let isLoggedIn = props.isLoggedIn;
  const location = useLocation();

  const showHomeListManagement = location.pathname === '/';
  const showTrustDatagentx = location.pathname === '/';
  const showHomeGetStarted = location.pathname === '/';


  useEffect(() => {
    const loggedInUser = localStorage.getItem("user");
    if(loggedInUser){
      isLoggedIn = true;
      let user = JSON.parse(loggedInUser)
      props.dispatch({ type: 'ADD_USER', user});
    }
  }, []);

  return (<>
    {/* <Router> */}
    <Header />
    {isLoggedIn && <SideBar />}
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot" element={<Forgot />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/ccpa-form" element={<CCPAForm />} />
      {isLoggedIn && (
        <>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/privacy-requests" element={<PrivacyRequests />} />
          <Route path="/ringba" element={<Ringba />} />
          <Route path="/pixel-log" element={<PixelLog />} />
        </>
      )}
    </Routes>

    {showHomeListManagement && <HomeListManagement />}
    {showTrustDatagentx && <HomeTrustDatagenetx />}
    {showHomeGetStarted && <HomeGetStarted />}


    <Footer />
    {/* </Router> */}
  </>
  );
}

const mapStateToProps = state => {
  return {
    user: state.userReducer.user,
    isLoggedIn: state.userReducer.isLoggedIn,
  };
};

export default connect(mapStateToProps)(App);


